export default {
    /**
     * Sets the current hash to the given value
     * @param {string} hash
     */
    setHash(hash) {
        location.hash = `#${ hash }`;
    },

    /**
     * Get current hash value
     * @return {string}
     */
    getHash() {
        return location.hash.replace('#', '');
    },

    /**
     * Resets the hash value
     */
    clearHash() {
        location.hash = '';
    },
};
